@if (loading()) {
  <app-button-loader></app-button-loader>
}
<ng-content></ng-content>
